import useTestStore from '../../../stores/testStore';
import React, { useState } from 'react';
import moment from 'moment';
import axios from 'axios';

const UploadVideo = () => {
    const newTestDoc = useTestStore(state => state.newTestDoc);
    const setNewTestDoc = useTestStore(set => set.setNewTestDoc);

    const [videoFile, setVideoFile] = useState(null);
    const [videoUrl, setVideoUrl] = useState("");
    const [uploading, setUploading] = useState(false);
    const [progress, setProgress] = useState(0);

    const uploadVideo = async () => {
        if (!videoFile) {
            alert("Please select a video file first.");
            return;
        }

        setUploading(true);
        setProgress(0);

        try {
            const formData = new FormData();
            formData.append("file", videoFile);
            formData.append("upload_preset", "ml_default");
            formData.append("cloud_name", "latest-sightings-upload");
            formData.append("folder", `/postTests/${moment().format('YYYY')}/${moment().format('MMMM')}/${newTestDoc.testTitle}/`);
            const publicId = `-${Math.random().toString(36).substring(2)}-${videoFile.name}`;
            formData.append("public_id", publicId);

            const response = await axios.post(
                `https://api.cloudinary.com/v1_1/latest-sightings-upload/video/upload`,
                formData,
                {
                    onUploadProgress: (event) => {
                        const percent = Math.round((event.loaded * 100) / event.total);
                        setProgress(percent);
                    }
                }
            );

            const data = response.data;

            if (!data.secure_url) {
                throw new Error("Upload failed. No URL returned.");
            }

            setVideoUrl(data.secure_url);
            setNewTestDoc({
                ...newTestDoc,
                postVideo: data.secure_url,
                imageHeight: data.height,
                imageWidth: data.width,
            });

        } catch (err) {
            console.error("Upload error:", err);
            alert("Failed to upload video. Please try again.");
        } finally {
            setUploading(false);
        }
    };

    return (
        <div>
            <br /><br />
            <input
                type="file"
                accept="video/*"
                onChange={(e) => {
                    setVideoFile(e.target.files[0]);
                    setVideoUrl("");
                    setProgress(0);
                }}
            />
            <button onClick={uploadVideo} style={{
                border: '1px solid var(--color-brand)',
                borderRadius: '8px',
                backgroundColor: 'color-mix(in srgb, var(--color-brand) 22%, var(--color-surface))',
                color: 'var(--color-text)',
                padding: '8px 14px',
                cursor: 'pointer'
            }}>
                Upload
            </button>

            {uploading && (
                <div style={{ marginTop: '20px', width: '100%', maxWidth: '500px' }}>
                    <p>Uploading: {progress}%</p>
                    <div style={{
                        height: '10px',
                        background: 'color-mix(in srgb, var(--color-surface-elevated) 82%, var(--color-brand) 18%)',
                        borderRadius: '5px',
                        overflow: 'hidden'
                    }}>
                        <div style={{
                            width: `${progress}%`,
                            height: '100%',
                            background: 'linear-gradient(120deg, var(--color-brand), var(--color-brand-strong))',
                            transition: 'width 0.3s ease'
                        }}></div>
                    </div>
                </div>
            )}

            <div style={{ marginTop: '20px' }}>
                <h1>Uploaded video will be displayed here:</h1>
                {videoUrl && <video src={videoUrl} controls style={{ width: '100%', maxWidth: '600px' }} />}
            </div>
        </div>
    );
};

export default UploadVideo;
